"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    dropzoneUploadFile: {
        id: 'atoms.dropzone.upload_file',
        defaultMessage: 'Upload File',
    },
    dropzoneUploadFiles: {
        id: 'atoms.dropzone.upload_files',
        defaultMessage: 'Upload Files',
    },
    dropzoneUploadFolder: {
        id: 'atoms.dropzone.upload_folder',
        defaultMessage: 'Upload Folder',
    },
});
//# sourceMappingURL=atoms.js.map